import { OwcTabs, OwcTab, OwcIconButton, OwcTypography } from '@one/react';
import React from 'react';
import '../../styles.scss';

/**
 * Renders a read only list of data clauses
 *
 * @copyright Roche 2022
 * @author Nick Draper
 */
class NavigationSidebar extends React.Component {
    /**
     * Constructor 
     * 
     * @param props The properties passed
     */
    constructor(props) {
        super(props);
        this.state = { hidden: false };
    }

    handleTabChange = (event) => {
      const value = event.detail;
      if(value !== this.props.selectedTab){
        this.props.onTabChange(value);
      }
    }

    /**
     * Renders the controls
     * @returns The JSX of the controls
     */
    render() {
      const iconString = (this.state.hidden === false ? "chevron_left" : "chevron_right");
         // Separate section headers (disabled) from clickable tabs
      const sections = [];
      let currentSection = null;
      this.props.tabs.forEach((tab) => {
        if (tab.disabled) {
          currentSection = { header: tab.text, tabs: [] };
          sections.push(currentSection);
        } else if (currentSection) {
          currentSection.tabs.push(tab);
        }
      });

      return (
        <div style={{display:"flex", justifyContent:"flex-start", height:"100%"}}>
          {
            this.state.hidden === false
            ?<div style={{display:"flex", flexDirection: "column"}}>
                {sections.map((section) => (
                  <div style={{width:'14em',textAlign:'center'}} key={`section-${section.header}`}>
                    <div style={{
                      padding: "0.5em 0.75em",
                      color: "var(--one-color-chart-blue-200)",
                      borderBottom: "2px solid var(--one-color-chart-blue-200)",
                      width: "100%",
                      boxSizing: "border-box"
                    }}>
                      <OwcTypography variant="caption" style={{fontWeight: "500",fontSize:'14px', color: "inherit"}}>
                        {section.header}
                      </OwcTypography>
                    </div>
                    <OwcTabs style={{ width:"100%",minWidth:'100%' }} direction="vertical" value={this.props.selectedTab} onValueChange={this.handleTabChange}>
                         {section.tabs.map((tab) => {
                        const isSelected = tab.text === this.props.selectedTab;
                        return (
                          <OwcTab 
                              key={`tab${tab.text}`} 
                              id={`tab${tab.text.replace(/(\s|&)/g,"-")}`}
                              value={tab.text}
                              selected={isSelected}
                              style={{
                                display:'flex',
                                justifyContent:'center',
                                ...(isSelected ? {
                                  "--one-color-interaction-active-base": "var(--one-color-blue-600)",
                                  "--one-color-interaction-active-brand-base": "var(--one-color-accent-white)",
                                } : {}),
                              }}
                              >
                            {tab.text}
                          </OwcTab>
                        );
                      })}
                    </OwcTabs>
                  </div>
                ))}
              </div>
            : ""
          }
          <div style={{backgroundColor:"#EEE", paddingTop:"0.3em"}}>
            <OwcIconButton icon={iconString} onClick={() => this.setState({hidden:!this.state.hidden})} />
          </div>
        </div>
      );
    }
}

NavigationSidebar.defaultProps = {
  selectedTab: "",
  tabs: [],
  onTabChange:() => {},
}

export default NavigationSidebar;
